import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum VolunteeringAllVolunteersPageTabId {
	AllVolunteers = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list of main tab droplist views on this page
 */
export enum VolunteeringAllVolunteersPageViewId {
	ApprovedVolunteers = 1,
	RemovedVolunteers = 2,
}


@Injectable({ providedIn: 'root' })
export class VolunteeringAllVolunteersService extends PageTabsLayoutPageService<VolunteeringAllVolunteersPageTabId, VolunteeringAllVolunteersPageViewId> {

	private static readonly _viewDroplistItems1: DroplistItem<never, VolunteeringAllVolunteersPageViewId>[] = [
		{
			uniqueId: VolunteeringAllVolunteersPageViewId.ApprovedVolunteers,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Approved Volunteers',
				hideText: 'never',
			},
		},
		{
			uniqueId: VolunteeringAllVolunteersPageViewId.RemovedVolunteers,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Removed Volunteers',
				hideText: 'never',
			},
		},
	];

	constructor() {
		super(VolunteeringAllVolunteersService._viewDroplistItems1, VolunteeringAllVolunteersService.name, VolunteeringAllVolunteersPageTabId.AllVolunteers, VolunteeringAllVolunteersPageViewId.ApprovedVolunteers);
	}

	public get viewId() {
		return VolunteeringAllVolunteersPageViewId;
	}

}